import React, { ReactElement } from "react";
import Loader from "components/global/Loader";
import "./Buttons.scss";
import cn from 'clsx';

interface Props {
  txt: string | ReactElement;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  isBordered?: boolean;
  isSecondary?: boolean;
  isPrimary?: boolean;
  isDelete?: boolean;
  isLoad?: boolean;
  isSmall?: boolean;
  isGreen?: boolean;
  handleClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;

}

const Button: React.FC<Props> = ({
  txt,
  disabled,
  handleClick,
  type,
  isBordered,
  isSecondary,
  isDelete,
  isLoad,
  isSmall,
  isGreen,
  className,
  isPrimary,
}) => {
  return (
    <div
      className={cn("button-wrapper",
        isGreen && "green",
        isBordered && "bordered", 
        isSecondary && "secondary",
        isPrimary && "primary", 
        isSmall && "small", 
        isDelete && "delete", 
        disabled && "disabled",
        className
      )}
    >
      <button
        type={type ?? "button"}
        // @ts-ignore
        onClick={e => handleClick?.(e)}
        disabled={disabled || isLoad}
      >
        {isLoad ? <Loader size={10} /> : txt}
      </button>
    </div>
  );
};

export default Button;
